import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6dfd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splash-view" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "audio-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "division" }, null, -1))
const _hoisted_5 = { class: "options nav-list" }
const _hoisted_6 = { class: "content" }

import {ref, computed, onMounted, inject} from 'vue'
  import {useStore} from 'vuex'
  import BigButton from '@/components/inputs/BigButton'
  import LazyImage from '@/components/LazyImage'

  import SpriteIcon from '@/components/SpriteIcon'
  import IconButton from '@/components/inputs/IconButton'
  import ButtonInput from '@/components/inputs/ButtonInput'
  import ModalOverlay from '@/components/ModalOverlay'
  import ContentSection from '@/components/ContentSection'
  import IconsExample from '@/components/IconsExample.vue'

  import CalledCoral from '@/components/CalledCoral'

  import {useRouter} from 'vue-router'
  import {usePreloader} from '@/lib/preloader'

  import {t} from '@/lib/i18n'
  import AudioSelectionForm from '@/components/forms/AudioSelectionForm.vue'
  import {useNavigable} from '@/lib/navigable'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ChartView',
  setup(__props) {

  const {getPreviousStateId} = useNavigable()

  usePreloader()

  const store = useStore()
  const router = useRouter()
  const bus = inject('bus')

  const titleText = computed(() => t(store, 'chart.title'))
  const buttonText = computed(() => t(store, 'listen_intro.actions.continue'))
  const otherButtonText = computed(() => t(store, 'splash.other'))
  const scienceText = computed(() => t(store, 'splash.other.info'))
  const cancelText = computed(() => t(store, 'back'))

  const showScience = ref(false)

  const audioLocations = store.state.audioLocations
  const translated = []
  audioLocations.forEach((item) => {
    translated.push({key: item.key, value: computed(() => t(store, item.key))})
  })

  const audioActive = ref(false)
  //const errors = ref({})

  onMounted(() => {
    // check previous route
    if (store.state.prevHistory == 'active.chart.science') {
      showScience.value = true
    }

    setTimeout(() => {
      audioActive.value = true
    }, 1)

    return
    /*
    const elements = document.querySelectorAll('.element')
    elements.forEach((element) => {
      element.style.display = 'none'
      element.style.opacity = 0
    })

    let currentElement = 0
    let prevElement = null
    const showNextElement = () => {
      // Hide the previous element
      if (prevElement) {
        prevElement.classList.remove('rotate-3d')
        prevElement.style.display = 'none'
        prevElement.style.opacity = 0
      }

      // Show the next element
      elements[currentElement].classList.add('rotate-3d')
      elements[currentElement].style.display = 'block'

      void elements[currentElement].offsetHeight

      elements[currentElement].style.opacity = 1
      prevElement = elements[currentElement]
      // Increment the currentElement index
      currentElement++

      // If we've reached the end, start over
      if (currentElement === elements.length) {
        currentElement = 0
      }
      setTimeout(showNextElement, 3000)
    }

    // Schedule the next element to be shown
    showNextElement()
    */
  })

  const onButtonClick = function () {
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click start listening'
      }
    })
    //store.state.prevHistory = "active.chart"
    store.state.prevHistory = 'active.chart'
    router.push({name: 'active.listen'})

    //router.push({name: 'active.chart'})
    //console.log("onButtonClick")
  }

  const onOtherButtonClick = function () {
    showScience.value = true
  }

  const onScience = function () {
    //router.push({name: 'active.listen'})

    router.push({name: 'active.listen-selection'})
  }

  const onModalClose = () => {
    showScience.value = false
  }

  const onSubmit = () => {
    //router.push({name: 'active.science-intro-intro'})
    store.state.prevHistory = 'active.chart.science'
    router.push({name: 'active.listen'})
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ContentSection), { class: "content audio-warning" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(titleText)), 1)
        ]),
        _: 1
      }),
      _hoisted_4,
      _createVNode(IconsExample),
      _createElementVNode("nav", _hoisted_5, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_unref(IconButton), {
              name: "submit",
              class: "enter",
              onClick: onButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_unref(ModalOverlay), {
        class: "science-modal",
        active: showScience.value,
        onClose: onModalClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_unref(otherButtonText)), 1),
            _createVNode(_unref(ContentSection), { innerHTML: _unref(scienceText) }, null, 8, ["innerHTML"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(AudioSelectionForm, {
              options: translated,
              errors: _ctx.errors,
              "model-value": {},
              onSubmit: onSubmit
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_unref(ButtonInput), {
                name: "close",
                priority: "secondary",
                onClick: onModalClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(cancelText)), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode(_unref(CalledCoral), { class: "shell" })
  ]))
}
}

})